import { hniBaseUrl } from "./API_URL";

export const baseURL =
  "https://cosmos.bajajfinservsecurities.in/api/ekycadmin";

export const ssobaseURL =
  "https://cosmos.bajajfinservsecurities.in/api/rm/Default";

export const baseURLOMS = "https://cosmos.bajajfinservsecurities.in/api/oms";

export const recordingURL = "https://callrecording.bajajfinservsecurities.in";

//hni baseurl
export const hniBaseURL = "https://cosmos.bajajfinservsecurities.in/api/hniekycadmin";

export const imgBaseUrl = "https://cosmos.bajajfinservsecurities.in/Imgs/telecallerImg"
export const telecallerImage = {
  whatsapp: imgBaseUrl + "/whatsapp.png",
  downloadimg: imgBaseUrl + "/download.png",
  serch: imgBaseUrl + "/circle.png",
  status: imgBaseUrl + "/status.png",
  name: imgBaseUrl + "/name.png",
  pan: imgBaseUrl + "/pan.png",
  date: imgBaseUrl + "/date.png",
  leadSo: imgBaseUrl + "/leadSo.png",
  mobile: imgBaseUrl + '/mobile.png',
  resumedate: imgBaseUrl + "/resumedate.png",
  score: imgBaseUrl + "/score.png",
  city: imgBaseUrl + "/city.png",
  edit: imgBaseUrl + "/edit.png",
  delete: imgBaseUrl + "/deleteico.png",
  calender: imgBaseUrl + "/calender.png",
  email: imgBaseUrl + "/email.png",
  gander: imgBaseUrl + "/gander.png",
  fname: imgBaseUrl + "/fname.png",
  filter: imgBaseUrl + "/filter.png",
  all: imgBaseUrl + '/all.png',
  monthly: imgBaseUrl + "/monthly.png",
  today: imgBaseUrl + "/today.png",
  person: imgBaseUrl + "/person.png",
  phone: imgBaseUrl + "/phone.png",
  pack: imgBaseUrl + "/pack.png",
  onlId: imgBaseUrl + "/onlId.png",
  activeDate: imgBaseUrl + "/activeDate.png",
  leadCategory: imgBaseUrl + "/leadCategory.png",
  leadIdUp: imgBaseUrl + "/leadIdUp.png",
  worning: imgBaseUrl + "/worning.png",
  trigger: imgBaseUrl + "/trigger.png",
  updatePack: imgBaseUrl + "/updatePack.png"

}
export const SERVICES = {
  ADMIN_DASHBOARD: baseURL + "/Admin/AdminDashboard", //
  REJECTION_DASHBOARD: baseURL + "/Admin/RejectionDashboard", //
  DELETE_DASHBOARD: baseURL + "/Admin/ClientDetailsDelete", //
  DELETE_APPLICATION: baseURL + "/Admin/DeleteApplication", //
  EDIT_APPLICATION: baseURL + "/Admin/EditApplication", //
  EMAIL_VALIDATED: baseURL + "/Admin/ValidateEMAILOTP", //
  SEND_EMAIL_OTP: baseURL + "/Admin/SendEMAILOTP", //
  CLIENT_DETAILS: baseURL + "/Admin/ClientDetails", //
  CLIENT_DETAILSV2: baseURL + "/Admin/v2/ClientDetails", //
  UPDATE_TELECALLER_DETAILS: baseURL + "/Admin/UpdateTeleClientDtls", //
  UPDATE_DOB_TELECALLER: baseURL + "/Admin/UpdateTeleClientDtls", //
  GET_PACK_DETAILS: baseURL + "/Admin/GetPackDetails", //
  HGS_DASHBOARD: baseURL + "/Admin/HGSDashboardV2", //
  HGSTableWiseDashboard: baseURL + "/Admin/HGSTableWiseDashboard", //
  HGSTableWiseDashboardV2: baseURL + "/Admin/v2/HGSTableWiseDashboard", //
  HGSDashboardOverAllBal: baseURL + "/Admin/HGSDashboardOverAllBal", //
  Telecaller360ClientDetails: baseURL + "/Admin/Telecaller360ClientDetails", //
  ChangeKratoNonKra: baseURL + "/Admin/ChangeKratoNonKra",
  GetAllDocuments: baseURL + "/Admin/GetAllDocuments", //
  WhatsappMSGToClient: baseURL + "/Admin/WhatsappMSGToClient", //
  ReasonMasterApi: baseURL + "/Admin/ReasonMasterApi",//
};

export const SSOSERVICES = {
  SSO_LOGOUT: ssobaseURL + "/V2/Logout",
  SSO_LOGIN: ssobaseURL + "/v2/AuthenticateSsoToken",
  SSO_LOGINV1: ssobaseURL + "/AuthenticateSsoToken",
};

export const OMSSERVICES = {
  OMS_CLIENT_DETAILS: baseURLOMS + "/Objection/ClientDetails",
  PENDIG_DATA: baseURLOMS + "/Objection/PendingData",
  GET_OBJECTIONS: baseURLOMS + "/Objection/GetObjections",
  PRIVIOUS_OBJECTION: baseURLOMS + "/Objection/PreviousObjection",
  ADD_OBJECTION: baseURLOMS + "/Objection/AddNewObjection",
  SAVE_REJECTION: baseURLOMS + "/Objection/SaveRejections",
  REJECTION_CUSTOMER: baseURLOMS + "/Objection/RejectedCustomers",
};

export const OMSHNI = {
  OMS_CLIENT_DETAILS_HNI_URL: baseURLOMS + "/Objection/HNIClientDetails",
  PENDIG_DATA_HNI_URL: baseURLOMS + "/Objection/GetHNIPendingData",
  GET_OBJECTIONS_HNI_URL: baseURLOMS + "/Objection/GetHNIObjections",
  PRIVIOUS_OBJECTION_HNI_URL: baseURLOMS + "/Objection/PreviousHNIObjection",
  ADD_OBJECTION_HNI_URL: baseURLOMS + "/Objection/AddNewHNIObjection",
  SAVE_REJECTION_HNI_URL: baseURLOMS + "/Objection/SaveHNIRejections",
  REJECTION_CUSTOMER_HNI_URL: baseURLOMS + "/Objection/HNIRejectedCustomers",
};

export const CALLSVICES = {
  CallRecordingDownloadReport:
    recordingURL + "/Dealer/CallRecordingDownloadReport",
  APKDownloadReport: recordingURL + "/Dealer/APKDownloadReport",
};
export const PACKUPDATE = {
  PlanUpgradationDetails: baseURL + "/Admin/PlanUpgradationDetails",
  SendEmailSms: baseURL + "/Admin/VerifyLinkAndSendEmail",
  EditPackTypeDetails: baseURL + "/Admin/EditPackTypeDetails",
};


//HNI telecaller APIS

export const HNISERVICESURL = {
  GetClientStatus: hniBaseURL + "/Admin/GetClientStatus",
  GetOverallBal: hniBaseURL + "/Admin/HGSDashboardOverAllBal",
  GetClientDetails: hniBaseURL + "/Admin/ClientDetails",
  GetEditedDetails: hniBaseURL + "/Admin/EditApplication",
  GetUpdatedClientDetails: hniBaseURL + "/Admin/UpdateTeleClientDtls",
  GetEmailOtp: hniBaseURL + "/Admin/SendEmailOtp",
  ValidateEmailOtp: hniBaseURL + "/Admin/ValidateEmailOtp",
  GetTableWiseDashboard: hniBaseURL + "/Admin/HGSTableWiseDashboard",
  GetDownloadFile: hniBaseURL + "/Admin/GetAllDocuments",
  SendMessage: hniBaseURL + "/Admin/WhatsappMSGToClient",
  getHniAdminDashboard: hniBaseURL + "/Admin/AdminDashboard",
  getHniRejectionDashboard: hniBaseURL + "/Admin/RejectionDashboard",
  getHniDeleteApplicationDetails: hniBaseURL + "/Admin/ClientDetailsDelete",
  getDeleteApplication: hniBaseURL + "/Admin/DeleteApplication",
  getDeleteReasons: hniBaseURL + "/Admin/ReasonMasterApi",


};


// Datta added for Telecaller Document delete @27-05-2026
export const DELETE_DOCUMENT = {
  Deletedocument: baseURL + "/Admin/DeleteDoc",
};
